import type { TTagsGateProps } from './TagsGate.types.ts';
import { useProjects } from '#providers/projects/use-projects/index.ts';

export const TagsGate = ({ loading, incomplete, children }: TTagsGateProps) => {
  const { settings, hasUnsetRequiredTags } = useProjects();

  if (!settings) {
    return loading;
  }

  if (hasUnsetRequiredTags) {
    return incomplete;
  }

  return children;
};
